import InspectionBoxHtml from './inspection.box.html';

export function InspectionsBoxDirective () {
  return {
    controller: 'InspectionsBoxCtrl',
    restrict: 'E',
    templateUrl: InspectionBoxHtml,
    scope: {
      inspections: '='
    }
  }
};